module.exports = __webpack_public_path__ + "static/media/cargo-partner.4acb8836.png";